var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgD1DeskChair(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40 45v8h7.69L53 65h-4.39l-3.53-8H40v8h-4v-8h-5.27l-3.51 8H23v-.33L28.12 53H36v-8H19V33a2 2 0 014 0v8h30v-8a2 2 0 014 0v12H40zm8-31.72A4.25 4.25 0 0043.75 9h-10.5A4.25 4.25 0 0029 13.25V37h19V13.28z",
    fill: "currentColor"
  })));
}
export default __webpack_public_path__ + "static/media/D1_Desk_chair.c923927f.svg";
export { SvgD1DeskChair as ReactComponent };